export default (function () {
  return { success: true };
});
//# sourceMappingURL=schema-validator.prod.js.map